
























import { defineComponent } from "@nuxtjs/composition-api";
import { useUiState } from "~/composables";
import HeaderLogo from "~/components/Header/HeaderLogo.vue";
import HeaderSearch from "~/components/Header/SearchBar/HeaderSearch.vue";
import HeaderStore from "~/components/Header/HeaderStore.vue";
import HeaderAcount from "~/components/Header/HeaderAcount.vue";
import HeaderCart from "~/components/Header/HeaderCart.vue";

export default defineComponent({
  components: {
    HeaderLogo,    
    HeaderSearch,    
    HeaderStore,
    HeaderAcount,
    HeaderCart,
  },
  setup() {
    const { isSearchPopupOpen, toggleSearchPopup } = useUiState();

    return {
      isSearchPopupOpen,
      toggleSearchPopup
    };
  },
  data() {
    return {
      lastScrollTop: 0,
      scrollDirection: '', // 'scroll-up' hoặc 'scroll-down'
    };
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      const currentScroll = window.pageYOffset || document.documentElement.scrollTop;

      if (currentScroll > this.lastScrollTop) {
        // Scroll xuống
        this.scrollDirection = 'scroll-down';
      } else if (currentScroll < this.lastScrollTop) {
        // Scroll lên
        this.scrollDirection = 'scroll-up';
      }

      this.lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
    }
  }
});
